// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BlogPostMenu__item--admin":"hv_a","BlogPostMenu__item--moderator":"hv_b"};